import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class LoadSpinner extends Component {
  render () {
    const { isFetching } = this.props;

    if (!isFetching) {
      return null;
    } 
    return (
      <div className="box_plus">
        <div className="foot_coupon">
          <span className="ico_loading" />
        </div>
      </div>
    );
  }
}

LoadSpinner.propTypes = {
  isFetching: PropTypes.bool.isRequired
};


// WEBPACK FOOTER //
// ./src/components/LoadSpinner/index.js